import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateOrganizationInfo } from '../../organization-actions';
import { getAsDraftContent, getContentStateAsHTML } from '../../../utils/draft-utils';
import RichEditor from '../../../components/rich-editor-2';
import ButtonText from '../../../components/button/button-text/ButtonText';
import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import { OrganizationDescriptionShow } from './OrganizationDescriptionShow';
import DescriptionWrapper from '../../../components/description-wrapper/DescriptionWrapper';
import { PRIMARY_ORGANIZATION_COLOR, WHITE_ORGANIZATION_COLOR } from '../../theme/OrganizationTheme';
import styles from './organization-description.module.less';

const OrganizationDescriptionEdit = ({ organization }) => {
    const [editorState, setEditorState] = useState(getAsDraftContent(organization?.description));
    const handleChange = useCallback((editorState) => setEditorState(editorState), []);
    const [editing, setEditing] = useState(false);
    const dispatch = useDispatch();

    const save = () => {
        const descriptionAsHTML = getContentStateAsHTML(editorState?.getCurrentContent());
        const updatedOrganization = { ...organization, description: descriptionAsHTML };
        dispatch(updateOrganizationInfo(updatedOrganization));
        setEditing(false);
    };

    if (editing) {
        return (
            <DescriptionWrapper className={styles.description} maxHeight={'3em'}>
                <RichEditor
                    onChange={handleChange}
                    handleUploadDescriptionImage={() => {}}
                    text={organization?.description}
                    className={[styles.editor, WHITE_ORGANIZATION_COLOR].join(' ')}
                    disableMedia
                />
                <div className={styles.editButtons}>
                    <ButtonText className={WHITE_ORGANIZATION_COLOR} onClick={() => setEditing(false)}>
                        Avbryt
                    </ButtonText>
                    <RoundedButtonPrimary className={PRIMARY_ORGANIZATION_COLOR} onClick={save}>
                        Lagre
                    </RoundedButtonPrimary>
                </div>
            </DescriptionWrapper>
        );
    }

    return (
        <div>
            <OrganizationDescriptionShow organization={organization} />
            <div className={styles.startEditButtonContainer}>
                <RoundedButtonSecondary onClick={() => setEditing(true)}>
                    <i className={'fa-regular fa-pen-to-square'} />{' '}
                    {organization?.description ? 'Rediger beskrivelsen' : 'Legg inn beskrivelse'}
                </RoundedButtonSecondary>
            </div>
        </div>
    );
};

export default OrganizationDescriptionEdit;
